<template>
  <div class="v-container">
    <div class="v-page-header">作品评论管理</div>
    <div class="v-header">
      <div class="filter-wroks v-mr-5">
        <el-select
          :value="worksName"
          placeholder="作品筛选"
          size="mini"
        ></el-select>
		<div class="filter-wroks-handle" @click="isShowWorkList = true"></div>
      </div>

      <el-select v-model="status" placeholder="状态筛选" size="mini">
        <el-option :value="1" label="待审核"></el-option>
        <el-option :value="2" label="通过"></el-option>
        <el-option :value="3" label="拒绝"></el-option>
      </el-select>
      <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)"
        >搜索</el-button
      >
      <el-button size="mini" @click="reset">重置</el-button>
    </div>
    <div v-loading="loading" class="v-content">
      <el-table size="small" border :data="lists" height="100%">
        <el-table-column label="用户头像" width="80" algin="center">
          <div slot-scope="scope">
            <el-avatar
              :src="scope.row.avatar"
              style="display: block; margin: 0 auto"
            ></el-avatar>
          </div>
        </el-table-column>
        <el-table-column
          label="用户昵称"
          prop="nickname"
          width="150"
        ></el-table-column>
        <el-table-column label="评论内容" prop="content"></el-table-column>
        <el-table-column
          label="所属作品"
          prop="worksName"
          width="150"
        ></el-table-column>
        <el-table-column
          label="提交时间"
          prop="createTime"
          width="200"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <div class="operate-row" slot-scope="scope">
            <el-dropdown
              class="select-btn"
              split-button
              :type="
                scope.row.status == 1
                  ? 'warning'
                  : scope.row.status == 2
                  ? 'success'
                  : 'danger'
              "
              size="min"
              @command="changeStaus($event, scope.row)"
            >
              <span v-if="scope.row.status == 1">待审核</span>
              <span v-if="scope.row.status == 2">通过</span>
              <span v-if="scope.row.status == 3">拒绝</span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="scope.row.status != 1" :command="1"
                  >待审核</el-dropdown-item
                >
                <el-dropdown-item v-if="scope.row.status != 2" :command="2"
                  >通过</el-dropdown-item
                >
                <el-dropdown-item v-if="scope.row.status != 3" :command="3"
                  >拒绝</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button
                slot="reference"
                size="min"
                class="v-ml-5"
                :loading="scope.row.deleteLoading"
                icon="el-icon-delete"
              ></el-button>
            </el-popconfirm>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        :current-page.sync="page"
        :total="total"
        @size-change="(pageSize) => getList(page, pageSize)"
        @current-change="(page) => getList(page)"
      ></el-pagination>
    </div>
	<works-list v-if="isShowWorkList" :show.sync="isShowWorkList" @select="onSelectWork"/>
  
  </div>
</template>

<script>
import worksList from "./components/works-list.vue";

export default {
  components: { worksList },

  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      lists: [],
      status: "", //1待审核 2通过 3拒绝
	  isShowWorkList:false,
	  worksName:'',
	  worksId:''
    };
  },
  created() {
    this.getList();
  },

  methods: {
    async getList(page, pageSize) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.pageSize = pageSize ? pageSize : this.pageSize;
      try {
        let res = await this.api.comment.listAll({
          page: this.page,
          pageSize: this.pageSize,
          status: this.status,
		  worksId:this.worksId
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

	onSelectWork(e){
		this.worksId = e.id;
		this.worksName = e.name;
		this.getList(1);
	},

    reset() {
      this.status = "";
	  	this.worksId = "";
		this.worksName = "";
      this.getList(1);
    },

    showAdd() {
      this.row = null;
      this.isShowAddEdit = true;
    },

    showAddEdit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    async changeStaus(status, row) {
      try {
        await this.api.comment.updateStatus({ id: row.id, status });
        row.status = status;
        this.$message.success("状态更新成功");
      } catch (e) {
        console.error(e);
      }
    },

    //删除
    async doDelete(row) {
      this.$set(row, "deleteLoading", true);
      try {
        await this.api.comment.delete({ id: row.id });
        this.$message.success("删除成功");
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, "deleteLoading", false);
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: flex-end;
}
.operate-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.select-btn ::v-deep .el-button-group {
  display: flex;
  align-items: center;
}
.select-btn ::v-deep .el-button-group .el-button:last-child {
  height: 22px;
}
.filter-wroks{
	position: relative;
}
.filter-wroks-handle{
	position: absolute;
	top:0;
	left:0;
	width: 100%;
	height: 100%;
	cursor: pointer;
}
</style>
